(() => {
  TrackApp.promoTracking = (() => {
    let impressionsQueue = [];

    let debouncedPush;

    function extractPromoData(element) {
      const page = ua.listName;
      const slotName = element.getAttribute('data-tracked-promo-slot');
      const numberInSlot = element.getAttribute('data-tracked-number-in-slot') || '';
      const mediaSrc = element.getAttribute('data-tracked-promo-src');
      const targetUrl = element.getAttribute('data-tracked-promo-target');
      return {
        creative: slotName,
        id: targetUrl,
        name: mediaSrc,
        position: `${page} - ${slotName} ${numberInSlot}`,
      };
    }

    const trackSinglePromoImpression = (element) => {
      impressionsQueue.push(extractPromoData(element));
      debouncedPush('promoImpressions');
    };

    let intersectionObserver;
    const monitorPromoImpressions = () => {
      if (!App.settings.monitorPromoImpressions) return;
      // Ignore impressions tracking for unsupported browsers
      if (typeof IntersectionObserver === 'undefined') return;

      if (intersectionObserver) intersectionObserver.disconnect();

      intersectionObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.intersectionRatio >= 0.2) {
            entry.target.setAttribute('data-viewed', '');
            intersectionObserver.unobserve(entry.target);
            trackSinglePromoImpression(entry.target);
          }
        });
      }, {
        root: null,
        rootMargin: '0px',
        threshold: 0.2,
      });

      [...document.querySelectorAll('[data-tracked-promo-slot]:not([data-viewed])')]
        .forEach((el) => intersectionObserver.observe(el));
    };

    const push = (event, data) => {
      dataLayer.push({ 'promo.data': undefined });
      dataLayer.push({ event, 'promo.data': data || impressionsQueue });
    };

    const monitorPromoClicks = () => {
      $('[data-tracked-promo-clickable]').on('click', (e) => {
        const $el = $(e.currentTarget);
        const $promoSlot = $el.closest('[data-tracked-promo-slot]');
        push('promoClick', [extractPromoData($promoSlot[0])]);
      });
    };

    const init = () => {
      debouncedPush = window.debounce((event) => {
        push(event);
        impressionsQueue = [];
      }, 100);

      monitorPromoImpressions();
      monitorPromoClicks();
    };

    return {
      init,
    };
  })();
})();
